<template>
  <div>
    <div v-if="teamStatus.code == 10">
      <div class="container__builderall--boxed">
        <p v-if="requestSended" v-html="t.team_account_request_sended"></p><br>
        <p v-html="t.team_account_request_analysis"></p>
        <div class="center" style="margin-top: 3rem">
          <img src="/internacional/public/team-account/request-sended.png">
        </div>
      </div>
    </div>

    <div v-else-if="teamStatus.code == 15">
      <div class="container__builderall--boxed">
        <p v-html="t.team_account_request_approved"></p>
        <div class="center" style="margin-top: 3rem">
          <img src="/internacional/public/team-account/request-sended.png">
        </div>
      </div>
    </div>

    <div v-else-if="teamStatus.code == 20">
      <div class="container__builderall--boxed">
        <p>{{t.label_ola}}, <b>{{team.nome_usuario_lider}} </b> !</p><br>
        <div v-html="t.team_account_request_active"></div>
        <div class="center" style="margin-top: 3rem">
          <img src="/internacional/public/team-account/request-sended.png">
        </div>
      </div>
    </div>

    <div v-else-if="teamStatus.code == 40">
      <div class="container__builderall--boxed">
        <p><b v-text="team.nome_usuario_lider"></b>,</p><br>
        <p v-html="t.team_account_request_rejected"></p>
        <p v-text="reason" style="color: #0295ff;font-style: italic;"></p>
        <div class="center" style="margin-top: 3rem">
          <img src="/internacional/public/team-account/request-sended.png">
        </div>
      </div>
    </div>

    <div v-else-if="teamStatus.code == 50">
      <div class="container__builderall--boxed">
        <div 
          class="builderall-block_error" 
          v-html="t.team_account_canceled"> 
          >
        </div>
        <!--<div class="center" style="margin-top: 3rem">
          <img src="/internacional/public/team-account/request-sended.png">
        </div> -->
        <!--<div class="center" style="margin-top: 40px">
          <button type="button" class="builderall-button background-primary">Quero minha conta time de volta!</button>
        </div> -->
      </div>
    </div>

    <div v-else class="row" style="padding:60px 0px">
      <!-- <div class="col-md-6 center">
        <div class="container__builderall--boxed" style="padding-top: 0">
          <div class='embed-container'>
            <iframe :src='handler_routes.url_team_video' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div> -->
      <div class="col-md-12 container__builderall--center">
          <div style="line-height: 1.3">
            <p><strong v-html="t.team_account_welcome_title"></strong></p>
            <p v-html="t.team_account_welcome_message"></p>
            <br><br>
            <div class="center">
              <button 
                type="button" 
                class="button3 extra-large" 
                @click="initModal()" 
                v-text="t.button_continuar"></button>
            </div>
         </div>
      </div>

      <div class="modal fade" id="modalRequestTeamAccount" tabindex="-1" role="dialog" aria-labelledby="modalRequestTeamAccount" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content builderall-modal">
            <div class="builderall-modal__header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h3 class="builderall-modal__header--title" v-text="t.send_confirm"> </h3>
            </div>
            <div class="builderall-modal__body">
              <form >
                <div class="form-group">
                  <label v-text="t.team_account_request_name_team"></label>
                  <input type="text" class="form-control" required="" v-model="data.nome">
                </div>
                <div class="form-group">
                  <label>
                    <span v-html="t.team_account_request_mail_team"></span>
                    <span class="field--required">*</span> 
                  </label>
                  <input 
                    type="email"  
                    required="" 
                    v-model="data.email" 
                    v-bind:class="['form-control', { 'field--error': errorMail === true }]">
                  <span 
                    class="field--text-error" 
                    v-if="errorMail" 
                    v-text="t.email_invalid_character">
                  </span>                 
                </div>
                <div 
                  class="builderall-modal__body--helper" 
                  v-html="t.team_account_request_form_help">
                </div>
                
              </form>
            </div>
            <div class="builderall-modal__footer center">
              <button type="submit" :class="['button3 extra-large', {'__loading': buttonSendDisabled}]" @click="sendSolicitation()" v-text="t.button_enviar"></button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "team-account-request",
  props: ["team","office_usuario_id","handler_routes","t","office_usuario_pag_status"],
  data() {
    return {
      data: {
        action: "request", 
        nome: "",
        email: "",
        id_leader: this.office_usuario_id,
        pag_status: this.office_usuario_pag_status
      },
      teamStatus: {
        code: 'REQUESTED',
        description: ''
      },
      errorMail: false,
      buttonSendDisabled: false,
      requestSended: false
    };
  },

  created(){
    if (this.team) {
      this.teamStatus.status_descricao = this.team.status_descricao
      this.teamStatus.code = this.team.status
    }
  },

  methods: {
    sendSolicitation(){
      if (this.checkForm()) {
      let vm = this;
      vm.buttonSendDisabled = true;
      axios.post(this.handler_routes.team, vm.data)
        .then(function (response) {
          if (response.data.status == 'success') {
            vm.teamStatus.code = response.data.data.status
            vm.requestSended = true
            $('#modalRequestTeamAccount').modal('hide')
            alertMsg('success', response.data.message)
          }
          else{
            alertMsg('error', response.data.message)
          }
        })
        .catch(function (error) {
          alertMsg('error', error)
        })
        .finally(() => (
          vm.buttonSendDisabled = false
        ))
      }
    },

    initModal(){
      this.errorMail = false;
      //pega todos os modais
      let allModals = document.querySelectorAll('#modalRequestTeamAccount');
      //verifica se existe um criado a mais e remove
      if(allModals.length == 2) allModals[0].remove();
      $('#modalRequestTeamAccount').modal('show');

    },

    checkForm(){
      if (!this.data.email) {
        //alertMsg('warning', 'O e-mail é obrigatório')
        this.errorMail = true;
        return false;
      } 
      else if (!this.validEmail(this.data.email)) {
        //alertMsg('warning', 'Utilize um e-mail válido!')
        this.errorMail = true;
        return false;
      }
      this.errorMail = false;
      return true;
    },

    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

  },
  computed: {
    reason(){
      if (this.team.observacao == null) {
        return
      }
      let jsonParsed = JSON.parse(this.team.observacao)
      return jsonParsed.reason
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/team-account/style.scss';
.modal-dialog {
  max-width: 500px; 
  width: unset;
}
p {
  line-height: 1.4rem;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/team-account/request.vue